'use client';

import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function BackButton() {
  return (
    <Button 
      onClick={() => window.history.back()} 
      className="w-full"
      variant="outline"
    >
      <ArrowLeft className="mr-2 h-4 w-4" />
      Go back
    </Button>
  );
}